import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentButtonAlign = createSelector(
  (state: AppState) => state.ai.button,
  button => button.align,
)
